import React from 'react';

export default function ImplBlock5Ecosystem() {
  return (
    <section className="py-24 md:py-24 px-6 md:px-16 bg-surface border-t border-line">
      <div className="max-w-[1280px] mx-auto flex flex-col items-center">
        
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-[24px] md:text-[32px] lg:text-[48px] font-bold text-ink mb-6 tracking-tight leading-[1.2]">
            BAC organiza qué acción operacional debe ocurrir. Los sistemas y equipos adecuados ejecutan cada parte.
          </h2>
          <p className="text-[16px] md:text-[16px] text-ink-soft">
            Las reglas clínicas no dependen del proveedor tecnológico.
          </p>
        </div>

        {/* Vertical Flow Diagram */}
        <div className="w-full max-w-xl flex flex-col items-center mb-16">
          <div className="w-full bg-paper border border-line py-4 px-4 text-[12px] font-semibold text-ink-soft tracking-widest uppercase text-center rounded-xl">
            DATOS APS
          </div>
          
          <div className="h-8 w-[2px] bg-gray-300 relative">
            <div className="w-0 h-0 border-l-[4px] border-l-transparent border-r-[4px] border-r-transparent border-t-[6px] border-t-gray-300 absolute top-full left-1/2 -translate-x-1/2"></div>
          </div>
          
          <div className="w-full bg-[#ccccff] py-6 px-4 text-[14px] font-semibold text-ink tracking-widest uppercase text-center rounded-xl mt-2 border border-brand/20">
            BAC
          </div>
          
          <div className="h-8 w-[2px] bg-gray-300 relative">
            <div className="w-0 h-0 border-l-[4px] border-l-transparent border-r-[4px] border-r-transparent border-t-[6px] border-t-gray-300 absolute top-full left-1/2 -translate-x-1/2"></div>
          </div>
          
          <div className="w-full bg-surface border-2 border-brand border-dashed py-4 px-4 text-[12px] font-semibold text-brand tracking-widest uppercase text-center rounded-xl mt-2">
            PRÓXIMA ACCIÓN
          </div>
          
          <div className="h-8 w-[2px] bg-gray-300 relative">
            <div className="w-0 h-0 border-l-[4px] border-l-transparent border-r-[4px] border-r-transparent border-t-[6px] border-t-gray-300 absolute top-full left-1/2 -translate-x-1/2"></div>
          </div>
          
          <div className="w-full bg-paper border border-line py-4 px-4 text-[12px] font-semibold text-ink-soft tracking-widest uppercase text-center rounded-xl mt-2">
            ADAPTADOR / FLUJO ASISTIDO
          </div>

          <div className="h-8 w-[2px] bg-gray-300 relative">
            <div className="w-0 h-0 border-l-[4px] border-l-transparent border-r-[4px] border-r-transparent border-t-[6px] border-t-gray-300 absolute top-full left-1/2 -translate-x-1/2"></div>
          </div>
          
          <div className="w-full bg-gray-100 border border-line py-6 px-4 text-[12px] font-semibold text-ink tracking-widest uppercase text-center rounded-xl mt-2">
            HIS · AGENDA · MENSAJERÍA · TELESALUD · EQUIPO
          </div>

          <div className="h-8 w-[2px] bg-gray-300 relative">
            <div className="w-0 h-0 border-l-[4px] border-l-transparent border-r-[4px] border-r-transparent border-t-[6px] border-t-gray-300 absolute top-full left-1/2 -translate-x-1/2"></div>
          </div>
          
          <div className="w-full bg-surface border-2 border-brand border-dashed py-4 px-4 text-[12px] font-semibold text-brand tracking-widest uppercase text-center rounded-xl mt-2">
            RESULTADO / EVENTO
          </div>

          <div className="h-8 w-[2px] bg-gray-300 relative">
            <div className="w-0 h-0 border-l-[4px] border-l-transparent border-r-[4px] border-r-transparent border-t-[6px] border-t-gray-300 absolute top-full left-1/2 -translate-x-1/2"></div>
          </div>
          
          <div className="w-full bg-[#ccccff] py-6 px-4 text-[14px] font-semibold text-ink tracking-widest uppercase text-center rounded-xl mt-2 border border-brand/20">
            BAC REEVALÚA
          </div>
        </div>

        <div className="bg-paper border border-line px-8 py-6 rounded-xl max-w-3xl text-center w-full">
          <p className="text-[14px] text-ink-soft">
            La experiencia de YMC que dio origen a BAC ha operado sobre datos provenientes de RAYEN y AVIS.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-4xl mt-12">
          <div className="bg-surface border border-line p-8 rounded-xl text-left">
            <h3 className="text-[12px] font-semibold text-brand tracking-widest uppercase mb-4">INTEGRACIÓN ADAPTABLE</h3>
            <p className="text-[16px] text-ink-soft leading-[1.6]">
              La integración se adapta a la realidad tecnológica de cada red: puede utilizar APIs cuando existen, intercambio estructurado, exportaciones o cargas programadas y flujos asistidos.
            </p>
          </div>
          <div className="bg-surface border border-line p-8 rounded-xl text-left">
            <h3 className="text-[12px] font-semibold text-brand tracking-widest uppercase mb-4">DATOS BAJO GOBERNANZA DE LA RED</h3>
            <p className="text-[16px] text-ink-soft leading-[1.6] mb-3">
              BAC opera únicamente sobre las fuentes y accesos acordados para cada implementación. Los roles, permisos, trazabilidad y condiciones de tratamiento de datos se definen con la institución correspondiente.
            </p>
            <p className="text-[16px] text-ink-soft leading-[1.6]">
              Se aplica el principio de utilizar únicamente la información necesaria para ejecutar la operación acordada.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
